var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatmentUtiEclipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1860,
    height: 406,
    viewBox: "0 0 1860 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 859,
    cy: -1048,
    r: 1454,
    fill: "#F5D447"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1391,
    cy: -1026,
    r: 1349,
    fill: "#5F51CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentUtiEclipse);
export default __webpack_public_path__ + "static/media/treatmentUTIEclipse.c529b7f1884af80c3be55e1bfb2f4316.svg";
export { ForwardRef as ReactComponent };